export default "__VITE_ASSET__BbCg79fs__"